import MarkdownIt from 'markdown-it'
import * as hljs from 'highlight.js'
import { MATH_REGEX, mathLiveToLatex } from '../lib/mathlive'

export default function markdownParser(body: string): string {
  if (!body) {
    return ''
  }
  const latexs = []
  while (body.match(MATH_REGEX)) {
    const match = body.match(MATH_REGEX)
    const index = latexs.length

    latexs.push(mathLiveToLatex(match[0]))
    body = body.replace(`${match[0]}`, `TMP_MATHLIVE_TMP_${index}`)
  }

  const md = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true,
    langPrefix: 'language-',
    highlight: function (str, lang) {
      if (lang && hljs.getLanguage(lang)) {
        try {
          return '<pre class="hljs"><code>' + hljs.highlight(lang, str, true).value + '</code></pre>'
        } catch (__) { }
      }

      return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>'
    }
  })

  // 数学の変換
  let renderedBody = md.render(body)
  for (let index = 0; index < latexs.length; index++) {
    const latex = latexs[index]
    const mathHtml = (window as any).MathLive.latexToMarkup(latex)
    renderedBody = renderedBody.replace(`TMP_MATHLIVE_TMP_${index}`, mathHtml)
  }

  renderedBody = renderedBody.split('<a ').join('<a target="_blank" ')
  return renderedBody
}
